export const noPrintId = "d-print-none-connected";
export const trimId = "trim-connected";
export const requiredId = "text-danger-connected";
export const chart16to9maxWidthId = "chart-16-to-9-maxwidth-connected";

export const IDLE_DELAY = 250;
export const BUTTON_ANIMATION_DELAY = 3000;
export const CLOSING_DELAY = 10000;
export const MUCH_LONGER_DELAY = 20000;

export const MAX_SAFE_INTEGER = 9007199254740991;

export const DUMMY_DEVICE_ID: Required<IDeviceId> = {
    designCode: "",
    deviceClass: 0,
    fabrication: 0,
    series: 0,
};

// IMPORTANTE: DO NOT CHANGE ANY NAME HERE, because of Object.values() !!!
export enum EDeviceClasses {
    // LUMiFrac, 8/12 channels, no optical
    Fracture,

    // LUMiFuge, 8 channels, single optical
    Fuge,

    // LUMiSizer, 12 channels, single optical
    Sizer,

    // LUMiSizer MWL, 12 channels, multiple opticals
    SizerMwl,

    // LUMiReader, single channel, multiple opticals
    Reader,

    // LUMiReader X-Ray, single channel, single optical
    XRay,

    // LUMiSizer Nano, 12 channels, multiple optical
    SizerNano,

    // LUMiSpoc
    Spoc,
}

export interface IDevice {
    series: number;
    designCode?: string;
    fabrication: number;
}

export interface ILicensedDevice extends IDevice {
    deviceClass: IDeviceClasses; // do not use this for checks, but rather LicenseService.getSopLicenses()
}

export interface IDeviceId extends IDevice {
    deviceClass: EDeviceClasses;
}

export interface IFakeMap<TValue> {
    [key: number | string]: TValue | undefined;
}

export type IDeviceClasses =
    | "LUMiFrac"
    | "LUMiFuge"
    | "LUMiReader X-Ray"
    | "LUMiReader"
    | "LUMiSizer"
    | "LUMiSpoc";
